export default __webpack_public_path__ + "static/media/023.919e8e72.jpg";